import styles from './profile-notifications.module.scss';
import { WCheckbox } from '../../wrappers/wrapper';
import { useContext } from 'react';
import dbService from '../../../services/database.service';
import { UserContext } from 'contexts/userContext';
import { NOTIFICATION_MAPPER } from 'utils/constants';

export default function ProfileNotifications() {
  const { user, setUser } = useContext(UserContext);
  const notifications = JSON.parse(user.notification!);

  const handleChange = (
    category: string,
    item: string,
    type: 'email' | 'in_app',
    value: boolean
  ) => {
    notifications[category][item][type] = value;
    setUser({ ...user, notification: JSON.stringify(notifications) });
    if (!user) return;
    dbService.updateUser(user?._id!, { notification: JSON.stringify(notifications) });
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <span className={styles.title}>Notifications</span>
        <div className={styles.list}>
          {Object.entries(notifications).map(([category, items]: any) => (
            <div key={category} className={styles.category}>
              <div className={styles.head}>
                <span className={styles.categoryTitle}>{NOTIFICATION_MAPPER[category]}</span>
                <div className={styles.options}>
                  <div className={styles.item}>
                    <span>Email</span>
                  </div>
                  <div className={styles.item}>
                    <span>In-app</span>
                  </div>
                </div>
              </div>
              {Object.entries(items).map(([item, preferences]: any) => {
                return (
                  <div key={item} className={styles.row}>
                    <span>{NOTIFICATION_MAPPER[item]}</span>
                    <div className={styles.options}>
                      <div className={styles.item}>
                        <WCheckbox
                        style={{color: "var(--color-white)"}}
                          checked={preferences?.email}
                          onChange={() =>
                            handleChange(category, item, 'email', !preferences?.email)
                          }
                        />
                      </div>
                      <div className={styles.item}>
                        <WCheckbox
                          style={{color: "var(--color-white)"}}
                          checked={preferences?.in_app}
                          onChange={() =>
                            handleChange(category, item, 'in_app', !preferences?.in_app)
                          }
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
